__turbopack_context__.v({
  "drawer": "BkuXQa_drawer",
  "items": "BkuXQa_items",
});
